import React, { useEffect, useState } from 'react'
import { getAnonSession } from '@fs/zion-session'
import Route from './Route'
import LoadingSpinner from './LoadingSpinner'
import GenericError from './GenericError'

export default function AnonSessionRoute({ LoadingComponent, ...props }) {
  const [loaded, setLoaded] = useState(false)
  const [error, setError] = useState(false)

  const LoadingEl = LoadingComponent || LoadingSpinner

  useEffect(() => {
    let mounted = true
    getAnonSession()
      .then(() => {
        mounted && setLoaded(true)
      })
      .catch(() => {
        mounted && setError(true)
      })
    return () => {
      mounted = false
    }
  }, [])

  if (error) return <GenericError />

  if (!loaded) return <LoadingEl />

  return <Route {...props} />
}
